import { Component, Input } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tapNextOrError } from '@platform-frontend/util';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../../../marketplace-transloco-scope';
import { Product } from '../../../product';
import { SaasApiKeyService } from '../saas-api-key.service';

@UntilDestroy()
@Component({
  selector: 'yat-saas-api-key',
  templateUrl: './saas-api-key.component.html',
  styleUrls: ['./saas-api-key.component.scss'],
  providers: [provideTranslocoScope(MARKETPLACE_TRANSLOCO_SCOPE)]
})
export class SaasApiKeyComponent {
  constructor(private saasApiKeyService: SaasApiKeyService) {}

  @Input()
  product: Product;

  @Input()
  apiKeys: string[] = [];

  @Input()
  showDescription: boolean = false;

  @Input()
  showRegenerateApiButton: boolean = false;

  regenerateMode: 'default' | 'regenerate' | 'regenerateInProgress' = 'default';

  regenerateApiKey(completeCallback: () => void): void {
    this.regenerateMode = 'regenerateInProgress';
    if (this.product.licenseTypes.length > 0 && this.apiKeys.length > 0) {
      this.saasApiKeyService
        .regenerateApiKey(this.product.licenseTypes[0], this.apiKeys[0])
        .pipe(
          tapNextOrError(() => this.completeRegenerate(completeCallback)),
          untilDestroyed(this)
        )
        .subscribe();
    } else {
      this.completeRegenerate(completeCallback);
    }
  }

  private completeRegenerate(completeCallback: () => void): void {
    this.regenerateMode = 'default';
    completeCallback();
  }

  prepareRegenerate(): void {
    this.regenerateMode = 'regenerate';
  }

  cancelRegenerate(): void {
    this.regenerateMode = 'default';
  }
}
